import { Button, Loading, Typography } from "@/components/atoms";
import { EmailNotificationPreferenceCard } from "@/components/organisms/ClientEmailNotifications";
import { NotificationAlertsCard } from "@/components/organisms/ClientNotificationAlerts";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useGetClientProfileQuery } from "@/redux/apis/clientProfile/clientProfileApi";
import { useClientScope } from "./ClientScopeContext";

export const SettingsEmailNotifications = () => {
  const { accountId } = useClientScope();
  const { data, isLoading, error, refetch } = useGetClientProfileQuery(accountId ? { accountId } : undefined);

  const renderContent = () => {
    if (isLoading) return <Loading className="relative min-h-[120px] !bg-transparent" />;

    if (error || !data)
      return (
        <div className="flex flex-col items-start gap-2">
          <Typography variant="paragraph" className="text-danger">
            {error ? getErrorMessages(error)[0] : "Unable to load your notification preferences."}
          </Typography>
          <Button variant="secondary" size="sm" onClick={refetch}>
            Try again
          </Button>
        </div>
      );

    return (
      <>
        <EmailNotificationPreferenceCard value={data.notification_emails} loginEmail={data.personal?.email} accountId={accountId} />
        <NotificationAlertsCard value={data.notifications} accountId={accountId} />
      </>
    );
  };

  return (
    <div className="flex flex-col gap-4">
      <Typography variant="title" className="text-neutral-black">
        Email Notifications
      </Typography>
      {renderContent()}
    </div>
  );
};
